import React, { forwardRef } from 'react';

import { createPortal } from 'react-dom';

import { type NotificationDestinationProps, type NotificationPortalProps, type NotificationPortalRef } from './types';

import { StyledDestination } from './styles';

export function NotificationPortal({ children, destination }: NotificationPortalProps) {
    const fragment = <>{children}</>;

    return destination?.current ? createPortal(fragment, destination.current) : fragment;
}

function Destination({ children }: NotificationDestinationProps, ref: NotificationPortalRef) {
    return <StyledDestination ref={ref}>{children}</StyledDestination>;
}

export const NotificationDestination = forwardRef(Destination);
